<template>
  <div class="c-crypto-icons">
    <img :src="icon" :alt="symbol" class="c-coinInfo__icon" :style="{width:size+'px',height:size+'px'}" />
  </div>
</template>
<script>
export default {
  components: {},

  props: {
    symbol: {
      type: String,
      require: false,
      default: "",
    },

    size: {
      type: String,
      require: false,
      default: "24",
    },
  },

  data() {
    return {
      imageUrl: "/img/coins/svg/",
    };
  },

  computed: {
    icon() {
      return this.imageUrl + this.symbol.toLowerCase() + "_.svg";
    },
  },

  methods: {},
};
</script>
